import React from 'react';
import { accent, darkPurple } from '../utils/colors';

const ContextSearchResults = ({ 
  search, 
  searchDropdown, 
  searchLoading, 
  searchResults, 
  expandedDescId, 
  setExpandedDescId, 
  onResultClick,
  setSearchDropdown, 
  setSearch, 
  searchInputRef,
  getSnippet,
  highlight,
  currentPage // 'matrix' или 'skills'
}) => {

  if (!search || !searchDropdown) return null;

  const handleResultClick = async (searchResult) => {
    console.log('ContextSearchResults: Клик по результату поиска:', searchResult);
    
    // Защита от повторных кликов
    if (searchResult._clicking) {
      console.log('ContextSearchResults: Клик уже обрабатывается, игнорируем');
      return;
    }
    searchResult._clicking = true;
    
    try {
      // Немедленно очищаем поиск и закрываем dropdown
      setSearch("");
      setSearchDropdown(false);
      
      // Убираем фокус с поля ввода
      if (searchInputRef.current) {
        searchInputRef.current.blur();
      }
      
      console.log('ContextSearchResults: Состояние поиска очищено, выполняем навигацию');
      
      // Выполняем навигацию с таймаутом
      const navigationPromise = onResultClick(searchResult);
      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error('Navigation timeout')), 5000)
      );
      
      await Promise.race([navigationPromise, timeoutPromise]);
      console.log('ContextSearchResults: Навигация выполнена успешно');
      
    } catch (error) {
      console.error('ContextSearchResults: Ошибка при навигации:', error);
      // В случае ошибки НЕ восстанавливаем поиск, чтобы не создавать циклы
    } finally {
      // Снимаем флаг обработки клика
      delete searchResult._clicking;
    }
  };

  return (
    <div 
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        background: '#fff',
        borderRadius: 14,
        boxShadow: '0 4px 24px #a259f733',
        zIndex: 200,
        maxHeight: 420,
        overflowY: 'auto',
        border: `1.5px solid ${accent}`,
        padding: 0,
        marginBottom: 0,
        width: '100%',
        minWidth: 360,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      onMouseEnter={() => {
        console.log('ContextSearchResults: Мышь вошла в результаты поиска');
      }}
      onMouseLeave={() => {
        console.log('ContextSearchResults: Мышь покинула результаты поиска');
      }}
    >
      {searchLoading ? (
        <div style={{ padding: 24, color: accent, fontSize: 18 }}>Поиск...</div>
      ) : searchResults.length === 0 ? (
        <div style={{ padding: 24, color: '#888', fontSize: 17 }}>Ничего не найдено</div>
      ) : (
        <>
          {/* Индикатор контекста */}
          <div style={{ 
            padding: '8px 16px', 
            background: currentPage === 'matrix' ? '#e3f2fd' : '#f3e5f5', 
            color: currentPage === 'matrix' ? '#1976d2' : '#7b1fa2',
            fontSize: 12,
            fontWeight: 600,
            width: '100%',
            textAlign: 'center',
            borderBottom: `1px solid ${accent}20`
          }}>
            {currentPage === 'matrix' 
              ? 'Откроет страницу навыка' 
              : 'Откроет в дереве навыков'
            }
          </div>
          
          {searchResults.map(res => {
            const desc = res.description || '';
            const snippet = getSnippet(desc, search);
            const isLong = desc.length > 100;
            const isExpanded = expandedDescId === res.id;
            return (
              <div
                key={res.id}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log('ContextSearchResults: onClick сработал для навыка:', res.id, res.title);
                  handleResultClick(res);
                }}
                onMouseUp={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                style={{
                  padding: '18px 22px',
                  borderBottom: '1px solid #f3eaff',
                  cursor: 'pointer',
                  background: '#f7f3ff',
                  color: darkPurple,
                  fontWeight: 500,
                  borderRadius: 10,
                  margin: 0,
                  transition: 'background 0.15s',
                  maxWidth: 700,
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#f0e9ff';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#f7f3ff';
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 2, textAlign: 'center' }}>
                  <span dangerouslySetInnerHTML={{ __html: highlight(res.title, search) }} />
                </div>
                {desc && (
                  <div 
                    style={{ fontSize: 15, color: '#6a1b9a', marginTop: 2, whiteSpace: 'pre-line', textAlign: 'center' }}
                    onClick={e => { e.stopPropagation(); setExpandedDescId(isExpanded ? null : res.id); }}
                  >
                    {isLong && !isExpanded
                      ? <><span dangerouslySetInnerHTML={{ __html: highlight(snippet, search) }} /> <span style={{ color: accent, cursor: 'pointer', fontWeight: 600 }}>развернуть</span></>
                      : <><span dangerouslySetInnerHTML={{ __html: highlight(desc, search) }} />{isLong && <span style={{ color: accent, cursor: 'pointer', fontWeight: 600 }}> свернуть</span>}</>
                    }
                  </div>
                )}
                {res.parentPath && res.parentPath.length > 0 && (
                  <div style={{ fontSize: 13, color: '#888', marginTop: 2, textAlign: 'center' }}>
                    {[...res.parentPath].reverse().map((p, idx, arr) => (
                      <span key={p.id}>{p.title}{idx < arr.length - 1 && ' / '}</span>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default ContextSearchResults;
